WiseMetering.Collection.Invoices = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.Invoice,
    url: '/invoices',

    filterByUtility: function(utility) {
        return new WiseMetering.Collection.Invoices(this.where({ utility_id: utility.id }));
    }
});
